if (!window) {
    throw ("A window object is required for configuration.");
}

const recommendedAgentMatchers = [
    /Chrome/,
    /Edge/,
    /Trident\/7.0/
];

const isRecommendedBrowser = recommendedAgentMatchers.some((exp) => {
    return exp.test(window.navigator.userAgent);
});

const Config = {
    IsRecommendedBrowser: isRecommendedBrowser,
    RootApiUrl: null,
    AdalClientID: null,
    MainViewNames: {
        SurveyList: "MAINVIEW.SURVEYLIST",
        Survey: "MAINVIEW.SURVEY",
        SurveyConfirmation: "MAINVIEW.SURVEYCONFIRMATION", 
        SurveySummary: "MAINVIEW.SURVEYSUMMARY",
        Impersonation: "MAINVIEW.IMPERSONATION",
        WalkThru: "MAINVIEW.WALKTHRU",
        LegacySurvey: "MAINVIEW.LEGACYSURVEY",
        Reports: "MAINVIEW.REPORTS"
    },
    UploadURL: "https://files.cubesmart.com/",
    ConfirmationPage: "Confirmation", 
    ServerRequestRetries: 4,
    ServerRequestDelayMS: 1000,
    AutoSaveTickTimeMins: 5, 
    AuditTypes: { // Order matters, here
        FacilityAudits: {
            FriendlyName: "Store Operations"
        },
        ApartmentAudits: {
            FriendlyName: "Residence"
        },
        CustomerReadinessAudits: {
            FriendlyName: "Customer Readiness"
        }, 
        ADAComplianceAudits: {
            FriendlyName: "FSM ADA Audit"
        }
    },
    Environments: {
        "prod": {
            RootApiUrl: "https://caudit.cubesmart.com/api/",
            AdalClientID: "c8b2a55d-8de4-4a26-a644-a8e130e8a072",
            AutoSaveTickTimeMins: 5
        },
        "stage": {
            RootApiUrl: "https://caudit.cubesmart.com/stage/api/",
            AdalClientID: "c8b2a55d-8de4-4a26-a644-a8e130e8a072",
            AutoSaveTickTimeMins: 5,
            AuditTypes: { // Order matters, here
                FacilityAudits: {
                    FriendlyName: "Store Operations"
                },
                ApartmentAudits: {
                    FriendlyName: "Residence"
                },
                ADAComplianceAudits: {
                    FriendlyName: "FSM ADA Audit"
                },
                CustomerReadinessAudits: {
                    FriendlyName: "Customer Readiness"
                },
                FacilityTrainingAudits: {
                    FriendlyName: "Store - Training"
                } 
                
            }
        },
        "dev": {
            RootApiUrl: "http://localhost:49300/api/",
            AdalClientID: "75d9e715-048b-4ae5-87a7-711bc944a394",
            ServerRequestRetries: 2,
            AutoSaveTickTimeMins: 60,
            AuditTypes: { // Order matters, here
                FacilityAudits: {
                    FriendlyName: "Store Operations"
                },
                ApartmentAudits: {
                    FriendlyName: "Residence"
                },
                CustomerReadinessAudits: {
                    FriendlyName: "Customer Readiness"
                },
                ADAComplianceAudits: {
                    FriendlyName: "FSM ADA Audit"
                }, 
                FacilityTrainingAudits: {
                    FriendlyName: "Store - Training"
                },
                DevAudits: {
                    FriendlyName: "Dev"
                }
            }
        }
    }
};

const envKey = (function () {
    if(window.location.host === "caudit.cubesmart.com") {
        if (window.location.pathname.match("stage")) {
            console.log("Using stage settings.");

            return "stage";
        }

        console.log("Using prod settings.");

        return "prod";
    }

    console.log("Using dev settings.");
    return "dev";
})();

const result = Object.assign({}, Config, Config.Environments[envKey]);

module.exports = result;


// WEBPACK FOOTER //
// ./src/config.js